<script lang="ts">
  import { page } from '$app/stores'
  import { popup, type PopupSettings } from '@skeletonlabs/skeleton'
  import type { Snippet } from 'svelte'

  import Icon from '$lib/components/Icon.svelte'

  interface Props {
    path?: string | undefined
    onclick?: () => void
    children?: Snippet
    listIcon?: boolean
    popupSettings?: PopupSettings
    hideActive?: boolean
    newTab?: boolean
  }

  let {
    path = undefined,
    onclick,
    children,
    listIcon,
    popupSettings,
    hideActive,
    newTab = false,
  }: Props = $props()
</script>

{#snippet childrenForA()}
  {#if listIcon}
    <span class="badge bg-secondary-500 text-white"
      ><Icon icon="iconoir:nav-arrow-right"></Icon></span
    >
    <span class="flex-auto">{@render children?.()}</span>
  {:else}
    {@render children?.()}
  {/if}
{/snippet}

{#if popupSettings && path}
  <li aria-current={$page.url.pathname.startsWith(path) ? 'page' : undefined}>
    <button use:popup={popupSettings}>
      {@render childrenForA()}
    </button>
  </li>
{:else if path}
  <li aria-current={$page.url.pathname === path && !hideActive ? 'page' : undefined}>
    <a
      href={path}
      target={newTab ? '_blank' : undefined}
      rel={newTab ? 'noreferrer noopener' : undefined}
    >
      {@render childrenForA()}
    </a>
  </li>
{:else if onclick}
  <li>
    <button {onclick}>{@render childrenForA?.()}</button>
  </li>
{:else}
  <li>
    <button>
      {@render childrenForA?.()}
    </button>
  </li>
{/if}

<style>
  li {
    position: relative;
    height: 100%;
  }

  li[aria-current='page']::before {
    --size: 6px;
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    top: 0;
    left: calc(50% - var(--size));
    border: var(--size) solid transparent;
    border-top: var(--size) solid var(--color-theme-1);
  }

  li a,
  li button {
    display: flex;
    height: 100%;
    align-items: center;
    padding: 0 0.5rem;
    color: var(--color-text-inverse);
    font-weight: 700;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    text-decoration: none;
    transition: color 0.2s linear;
  }

  li button {
    background: none;
    border: none;
    cursor: pointer;
  }

  li a:hover,
  li button:hover {
    color: var(--color-theme-1);
  }
</style>
